export const programmes = {
  "lose-weight": { id: "ffffffff-ffff-4fff-0001-000000000001", name: "Lose Weight" },
  "sitting-on-chairs": { id: "ffffffff-ffff-4fff-ffff-000000000001", name: "Sitting on Chairs" },
  "smoke-free": { id: "ffffffff-ffff-4fff-0002-000000000001", name: "Smoke Free" },
  "standing-on-tables": { id: "ffffffff-ffff-4fff-fffe-000000000001", name: "Standing on Tables" },
};
